module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_yycj_three.6fc4e0f7.png";